var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyCommentIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon empty-comment-icon",
    width: 70,
    height: 63,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-4h70v70H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M59.76 0C65.42 0 70 4.45 70 9.9v29.24c0 5.47-4.6 9.9-10.24 9.9h-4.3v11.97c0 .8-.5 1.53-1.26 1.84a2.2 2.2 0 01-2.27-.4l-14.47-13.4H10.24C4.58 49.04 0 44.58 0 39.14V9.9C0 4.43 4.6 0 10.24 0h49.52zm.1 2H10.14C5.64 2 2 5.51 2 9.8v29.4c0 4.28 3.63 7.8 8.14 7.8h28.14l.6.56L53.37 61V47h6.5c4.5 0 8.14-3.51 8.14-7.8V9.8C68 5.52 64.37 2 59.86 2zM21.74 9.76l4.13 4.13a14 14 0 0119.74 19.74l4.13 4.13a1.05 1.05 0 11-1.48 1.48l-4.13-4.13a14 14 0 01-19.74-19.74l-4.13-4.13a1.05 1.05 0 111.48-1.48zM23.1 24.5a11.9 11.9 0 0019.54 9.12L25.88 16.86a11.85 11.85 0 00-2.78 7.64zM35 12.6c-2.9 0-5.57 1.04-7.64 2.78l16.76 16.76A11.9 11.9 0 0035 12.6z"
  }))));
}

export default SvgEmptyCommentIconSv;